"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _reactRhumb = require("react-rhumb");

var _Tracking = require("../constants/Tracking");

function ErrorPage() {
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().track('pageView', {
      screen: _Tracking.SCREENS.ERROR
    });
  }, []);
  return _react.default.createElement("div", {
    className: "flex-column align-center p-all-10"
  }, _react.default.createElement(_reactRhumb.NavMarker, {
    name: "ERROR_PAGE"
  }), _react.default.createElement(_UIIllustration.default, {
    className: "m-y-10",
    name: "errors/general",
    height: 200
  }), _react.default.createElement("h4", {
    className: "m-top-6"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "errorPage.title"
  })), _react.default.createElement("p", {
    className: "m-bottom-10"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "errorPage.paragraph"
  })));
}

var _default = ErrorPage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/ErrorPage.js
// module id = 264
// module chunks = 5 6